/** --------------------------------------------------
*
*   components
*   TEXT CONTENT
*
*  -------------------------------------------------- */

(function ($, Drupal, once, duo) {
  Drupal.behaviors.text_content = {

    attach: function(context, settings) {
      const self = this;

      // only do the following once:
      $(once('text_content', 'html', context)).each(function() {
        self.init(context, settings);
      });
    },

    init: function(context, settings) {

      // setup tables:
      this.setupTables(context);
    },

    setupTables: function(context) {
      const self = this;

      /*
      * wrap the tables in a ".text-content" block inside an extra wrapper;
      * we need the wrapper to be able to add scrollbars to the table on smaller
      * viewports
      */

      $(context).find('.text-content table').each(function(index, element) {
        const $table = $(element);
        $table.wrap('<div class="text-content-table-wrapper"></div>');
      });

      /*
      * if we need to scroll inside the table, we need to add a tabindex
      * so the user can focus the table using the keyboard
      */

      self._fixTableTabIndex();
      // -> recalculate on resize (with debouncing):
      let timeout = false;
      $(window).on('resize.textcontent', function() {
        clearTimeout(timeout);
        timeout = setTimeout(self._fixTableTabIndex(), 250);
      });
    },

    _fixTableTabIndex: function() {
      $(document).find('.text-content .text-content-table-wrapper').each(function(index, element) {
        const $wrapper = $(element);
        const $table = $wrapper.find('> table');

        const wrapperWidth = $wrapper.width();
        const tableWidth = $table.width();

        if(tableWidth > wrapperWidth) {
          $wrapper.attr('tabindex', '0');
        } else {
          $wrapper.removeAttr('tabindex', '');
        }
      });
    }
  };
})(jQuery, Drupal, once, window.duo = window.duo || {});
